module.exports = __webpack_public_path__ + "img/QA_ScUber_WR.40f07bc.png";